import Facade from "../Facade";
import {loginLogin} from "../actions";

export default function runRefreshMine(dispatch){
  Facade.gw.getMine(({id,nickName,avatarUrl})=>{
    dispatch(loginLogin(id,nickName,avatarUrl));
  })
}
